//@flow
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import ActivityPopover from '../activity/ActivityPopover';
import { GetActivityMsg, GetActivityQuery, HelpQuery, PathFuidsList } from '../autogenerated/ZoomBridge';
import ThumbnailUtil from '../util/ThumbnailUtil';
import FavoriteContent from './home/FavoriteContent';
import SpotlightContent from './home/SpotlightContent';
import HomeTabUpload from '../dnd/HomeTabUpload';
import ErrorHandler from '../error/ErrorHandler';
import Authenticator from '../protocol/Authenticator';
import ActivityPanel, { ActivityTabs } from './home/activity/ActivityPanel';
import NotificationController from '../controllers/NotificationController';
import Storage from '../protocol/Storage';
import { HeightLeftWithoutHeaderInCalc, isMobile } from '../util/ScreenUtil';
import HomeBanner from './home/HomeBanner';
import ViewUtil from '../ViewUtil';
import t from '../i18n/I18n';
import { getAssetPathFuids } from '../util/RepoItemUtil';
import Lazyload from '../lazyload/LazyLoad';
import Store from '../store/Store';
import { ALL_FILES_OPTION } from '../store/Constants';
import HelpUtil from '../util/HelpUtil';

const MobileHomeTab = Lazyload(() => import('./MobileHomeTab'));

const debug = require('../debug/debug')('wc:tabs:HomeTab');
export default class HomeTab extends React.Component {
  static propTypes = {
    onClickEvent: PropTypes.func.isRequired,
    issueSearchOnFuid: PropTypes.func
  };

  state = {
    showActivityPopover: false,
    isEditingSpotlightContent: false,
    loadingActivities: false
  };

  componentDidMount() {
    /*var key = HelpUtil.getHelpKey(ViewUtil.getPageName())
    var response =  HelpQuery.getHelp(key);*/

    NotificationController.getInstance().clearTimer();
    if (window.gs.activities == null) {
      this.issueGetActivityQuery();
    } else {
      this.issueGetActivityQuery(true);
    }
    window.gs.notificationInfo.activities = [];
    //window.addEventListener('focus', this.loadActivity);
  }

  componentWillUnmount() {
    //window.removeEventListener('focus', this.loadActivity);
  }

  loadActivity = () => {
    this.issueGetActivityQuery();
  };

  issueGetActivityQuery(leadingEntries = false, trailingEntries = false) {
    if (!window.gs.isExternalUser) {
      const getActivityQuery = new GetActivityQuery();
      const msg = new GetActivityMsg();
      if (window.gs.activityInfo.onlyNotifications) msg.setOnlyNotifications(true);
      if (window.gs.activityInfo.onlyTasks) msg.setOnlyTasks(true);

      if (leadingEntries === true) {
        msg.setMtime(window.gs.activityInfo.latestTime);
      }

      if (trailingEntries === true) {
        msg.setMtime(window.gs.activityInfo.oldestTime);
        msg.setOldestTimeDateLabel(window.gs.activityInfo.oldestEntryDateLabel);
        msg.setIsMaxTime(true);
      }

      getActivityQuery.message = msg;
      getActivityQuery.run().then(
        (resp) => {
          if (leadingEntries === true) {
            if (
              window.gs.activityInfo.latestTimeDateLabel &&
              window.gs.activityInfo.latestTimeDateLabel == resp.getLatestTimeDateLabel()
            ) {
              const item = window.gs.activities.shift();
              item.setDateLabel(null);
              window.gs.activities.unshift(item);
            }
            _.eachRight(resp.getActivityList(), (__activity) => {
              window.gs.activities.unshift(__activity);
            });
          } else if (trailingEntries === true) {
            if (_.isEmpty(resp.getActivityList())) {
              window.gs.activityInfo.noMoreLeadingEntries = true;
            } else {
              _.each(resp.getActivityList(), (__activity) => {
                window.gs.activities.push(__activity);
              });
            }
            this.setState({ loadingActivities: false });
          } else {
            window.gs.activities = resp.getActivityList();
          }
          if (!trailingEntries) {
            if (!window.gs.activityInfo.latestTime || window.gs.activityInfo.latestTime < resp.getLatestTime()) {
              window.gs.activityInfo.latestTime = resp.getLatestTime();
              Storage.set(NotificationController.activityInfoLatestTime, resp.getLatestTime());
              window.gs.activityInfo.latestTimeDateLabel = resp.getLatestTimeDateLabel();
            }
          }
          if (!leadingEntries) {
            if (!window.gs.activityInfo.oldestTime || window.gs.activityInfo.oldestTime > resp.getOldestTime()) {
              window.gs.activityInfo.oldestTime = resp.getOldestTime();
              window.gs.activityInfo.oldestEntryDateLabel = resp.getOldestTimeDateLabel();
            }
          }

          NotificationController.getInstance().resetTimer();
          window.render();
        },
        (error) => {
          this.setState({ loadingActivities: false });
          ErrorHandler.handleError(error);
          NotificationController.getInstance().resetTimer();
        }
      );
    }
  }

  onAssetClick = async (asset) => {
    if (asset._isFile !== undefined ? !asset._isFile : ThumbnailUtil.isFolder(asset._fqPath)) {
      const pathFuids: number[] = await getAssetPathFuids(asset._fuid);
      ViewUtil.switchToAssetsTabFolder(pathFuids);
    } else {
      ViewUtil.switchToAssetDetailView(asset._fuid, true);
    }
  };

  render() {
    if (isMobile()) {
      return <MobileHomeTab {...this.props} onAssetClick={this.onAssetClick} styleHeader={styles.headerText} />;
    }
    //const fuid2FavItemDetailMap = Store.get(FAV_ITEM_DETAIL_MAP); //window.gs;
    const showFav = this.state.favItems && this.state.favItems.size();
    return (
      <div style={{ height: HeightLeftWithoutHeaderInCalc, overflow: 'hidden' }} name="HomeTab">
        <div style={{ float: 'left', width: 'calc(100% - 370px)', height: '100%', overflow: 'auto' }}>
          <HomeBanner />
          <div style={{ width: '80%', margin: '0 auto 30px auto' }}>
            <div style={{ marginTop: '25px' }}>
              <div style={{ ...styles.headerText }}>{t('EASY_UPLOAD')}</div>
              <HomeTabUpload />
            </div>
            <FavoriteContent onAssetClick={this.onAssetClick} styleHeader={styles.headerText} />
            <SpotlightContent onAssetClick={this.onAssetClick} marginTop={showFav ? 10 : 40} />
          </div>
        </div>

        {window.gs.activities == null ? null : (
          <ActivityPanel
            ref="activityPanel"
            displayedBy="HomePage"
            activities={window.gs.activities}
            loadMoreActivities={() => this.loadMoreActivities()}
            loadingActivities={this.state.loadingActivities}
            onClickEvent={(activity) => this.props.onClickEvent(activity)}
          />
        )}
      </div>
    );
  }
  switchActivityToCommentTab = () => {
    if (this.refs.activityPanel) this.refs.activityPanel.switchTab(ActivityTabs.NOTIFICATIONS);
  };

  loadMoreActivities() {
    if (!window.gs.activityInfo.noMoreLeadingEntries && this.state.loadingActivities == false) {
      this.setState({ loadingActivities: true });
      this.issueGetActivityQuery(false, true);
    }
  }

  getHomeHeaderPicUrl() {
    return ThumbnailUtil.getHomeHeaderPicUrl(Authenticator.AUTH_DATA.username);
  }

  onSelectionChangeInActivity(value) {
    const header = this.refs.activityPanel.refs.header;
    if (header.innerHTML != value) {
      header.innerHTML = value;

      if (value === 'ALL_ACTIVITY') this.changeActivityFilter(false, false);
      else if (value === 'TASKS') this.changeActivityFilter(true, false);
      else if (value === 'NOTIFICATIONS') this.changeActivityFilter(false, true);
    }
  }

  changeActivityFilter(onlyTasks, onlyNotifications) {
    window.gs.activityInfo.noMoreLeadingEntries = false;
    window.gs.activityInfo.onlyTasks = onlyTasks;
    window.gs.activityInfo.onlyNotifications = onlyNotifications;
    if (window.gs.isExternalUser) {
      this.issueGetActivityQuery();
    }
  }
}

const styles = {
  headerText: {
    color: 'var(--secondary-font-color)',
    fontSize: '12px',
    fontWeight: '600',
    letterSpacing: '1px',
    lineHeight: '15px',
    marginBottom: '10px'
  },
  companyDetails: {
    color: '#B5B5B5',
    position: 'absolute',
    bottom: '20px',
    textAlign: 'center',
    width: '100%'
  },
  companyName: {
    display: 'block',
    marginBottom: '11px',
    height: '29px',
    color: '#FFFFFF',
    fontSize: '24px',
    fontWeight: '600',
    lineHeight: '29px',
    textAlign: 'center'
  },
  companyTagLine: {
    height: '19px',
    color: '#B5B5B5',
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '19px',
    textAlign: 'center'
  }
};
